
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/viaje",
      function () {
        return require("private-next-pages/[region]/[resort]/viaje.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/viaje"])
      });
    }
  